import { Component, Input, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { NzMessageService } from 'ng-zorro-antd/message';
import { NzModalRef, NzModalService } from 'ng-zorro-antd/modal';
import { PatrolGroupService } from '../../../service/patrol-group.service';
import { PatrolTemplateService } from '../../../service/patrol-template.service';

@Component({
  selector: 'app-facility-group-info',
  templateUrl: './facility-group-info.component.html',
  styleUrls: ['./facility-group-info.component.less']
})
export class FacilityGroupInfoComponent implements OnInit {

  @Input() data: any; // data为null表示新增，否则表示修改
  validateForm: FormGroup;
  uploading = false;
  loading = false;
  templates = [];

  constructor(
    private fb: FormBuilder,
    private modalRef: NzModalRef,
    private modal: NzModalService,
    public message: NzMessageService,
    private groupService: PatrolGroupService,
    private patrolTemplateService: PatrolTemplateService
  ) { }

  ngOnInit(): void {
    this.initTemplates();
    if (this.data == null) {
      this.validateForm = this.fb.group({
        groupName: new FormControl({ value: null, disabled: false }, [Validators.required, Validators.maxLength(20)]),
        groupType: new FormControl({ value: null, disabled: false }, [Validators.required]),
        ptno: new FormControl({ value: null, disabled: false }),
      });
    } else {
      this.validateForm = this.fb.group({
        groupName: new FormControl({ value: this.data.groupName, disabled: false }, [Validators.required, Validators.maxLength(20)]),
        groupType: new FormControl({ value: this.data.groupType, disabled: true }, [Validators.required]),
        ptno: new FormControl({ value: this.data.ptno, disabled: false }),
      });
    }
  }
  async saveEpData(){
    if (this.data === null ) {
      // 新添加需要判断巡检组是否已经存在
      const eg: any = await this.groupService.queryGroupByName(this.validateForm.value.groupName);
      if (eg.data !== null) {
        this.message.create('warning', '巡检组已存在，巡检组名称已占用!');
        return;
      }
      const result: any = await this.groupService.addGroup({
        groupName: this.validateForm.value.groupName,
        groupType: this.validateForm.value.groupType,
        ptno: this.validateForm.value.ptno,
      });
      if (result.code === 200) {
        this.message.create('success', '创建巡检组成功!');
        this.modalRef.destroy();
      } else {
        this.message.create('error', '创建物巡检组失败!');
      }
    }else {
      if (this.validateForm.value.groupName !== this.data.groupName) {
        // 巡检组名称修改后需判断巡检组是否已经存在
        const eg: any = await this.groupService.queryGroupByName(this.validateForm.value.groupName);
        if (eg.data !== null) {
          this.message.create('warning', '巡检组已存在，巡检组名称已占用!');
          return;
        }
      }
      this.data.groupName = this.validateForm.value.groupName;
      this.data.ptno = this.validateForm.value.ptno;
      const result: any = await this.groupService.editGroup(this.data);
      if (result.code === 200) {
        this.message.create('success', '修改巡检组成功!');
        this.modalRef.destroy();
      } else {
        this.message.create('error', '修改巡检组失败!');
      }
    }
  }

  cancelData(){
    this.modalRef.destroy();
  }
  initTemplates(){
    this.patrolTemplateService.getPatrolTemplates()
    .subscribe(data => {
      if (!this.isEmpty(data)){
        const listOfOption: Array<{ value: string; text: string }> = [];
        data.forEach(item => {
          listOfOption.push({
            value: item.ptNo,
            text: item.ptName
          });
        });
        this.templates  = listOfOption;
        }
    });
  }
  public isEmpty(obj: any) {
    if (typeof obj === 'undefined' || obj === null || obj === '') {
      return true;
    } else {
      return false;
    }
  }
}
